import { ApiResponse } from '../redux/services/types/types';

export const handleResponse = <T>(res: ApiResponse<T>) => {
  if (res.statusCode >= 400 && res.statusCode < 500) {
    if (res.error.length) {
      throw new Error(res.error[0].errorMessage);
    }
    throw new Error('Bad Request');
  }

  if (res.statusCode >= 500) {
    throw new Error('Internal Server Error');
  }

  return res;
};
